import { render, staticRenderFns } from "./WebhookFailedNotification.vue?vue&type=template&id=205fafc7&scoped=true&"
import script from "./WebhookFailedNotification.vue?vue&type=script&lang=js&"
export * from "./WebhookFailedNotification.vue?vue&type=script&lang=js&"
import style0 from "./WebhookFailedNotification.vue?vue&type=style&index=0&id=205fafc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fafc7",
  null
  
)

export default component.exports